import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import Notifications from 'vue-notification'

import BootstrapVue from 'bootstrap-vue'
import VueMask from 'vue-the-mask'
import moment from 'moment'
import axios from 'axios'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.use(BootstrapVue)
Vue.use(Notifications)
Vue.use(VueMask)

Vue.filter('formatYesNo', function (value) {
  if (value) {
    return 'Yes'
  }
  return 'No'
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatAge', function (value) {
  if (value) {
    var today = new Date();
    var birthDate = new Date(value)
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
  }
})

Vue.filter('formatPhone', function (valor) {
  if (valor) {
    return valor.substring(0, 3) + ' (' + valor.substring(3, 5) + ') ' + valor.substring(5, 10) + '-' + valor.substring(10, 14)
  }
})

Vue.filter('formatDateHour', function (value) {
  if (value) {
    return moment.parseZone(String(value)).format('DD/MM/YYYY HH:mm')
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment.parseZone(String(value)).format('DD/MM/YYYY HH:mm:ss')
  }
})

Vue.filter('escapeHtml', function (html) {
  if (html) {
    return html.replace(/<\/?[^>]+>/ig, " "); 
  }
})

Vue.filter('formatCurrency', function (value) {
  if (value) {
    var formated = (value).toFixed(2).replace('.', ',')
    return 'R$ ' + (formated).toLocaleString('pt-BR')
  }
})

Vue.filter('formatCPF', function (value) {
  if (value) {
    value = value.padStart(11, '0')
    value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    return value
  }
})

Vue.prototype.$http = axios; 

axios.interceptors.response.use(
  response => response,
  error => {
    const { status } = error.response
    if (status === 401) {
      if (router.currentRoute.name !== 'login') {
        router.push({ name: 'login' })
      }
    }
    console.log(error.response)
    var msg = (error.response.data.message) ? error.response.data.message : error.response.status + ' ' + error.response.statusText
    Vue.notify({group: 'alert', type: 'error', title: 'Request Error', text: msg})
    return Promise.reject(error)
  }
)
// Vue.prototype.$axios = axios


const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
